import { APP_DATA_VERSION } from '../constants';

export default class LocalStorageCleaner {
  static cleanStateIfNeeded() {
    let currentAppVersion = localStorage.getItem('appVersion');

    if (currentAppVersion !== APP_DATA_VERSION) {
      // clean up local storage
      localStorage.clear();
    }

    // set the current app version
    localStorage.setItem('appVersion', APP_DATA_VERSION);
  }
}
